export const SCOPE_MASTER = "master";
export const SCOPE_CMS = "apps.cms";
export const SCOPE_CONSOLE = "apps.console";
export const SCOPE_WEBSITES_MANAGE = "websites_manage";
export const SCOPE_APARTMENTS = "apps.apartments";
export const SCOPE_WEBSITES_DEV = "websites.dev";
export const SCOPE_WEBSITES_POWER_USER = "websites.power_user";
